<template>
  <div>
    <el-select
      @visible-change="visibleChange"
      :value="selectValue"
      @clear="handleClear"
      :clearable="clearable"
      ref="select"
    >
      <el-option :value="null" class="pagoda-cascader">
        <el-input
          v-if="filterable"
          class="search-input"
          v-model="searchCenter"
          @click.native.stop
          placeholder="请输入内容">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-tabs
          :style="{width: 110 * rowCount  + 'px'}" 
          @click.native.stop
          v-model="activeName"
          :tab-position="isHeaderLeft ? 'left' : 'top'"
          v-if="!searchCenter"
          :class="{headerLeft: isHeaderLeft}"
        >
          <el-tab-pane
            v-for="it in options"
            :key="it[valueKey]"
            :label="it[labelKey]"
            :name="it[valueKey]"
          >
            <div class="list-box">
              <div
                :title="item[labelKey]"
                v-for="item in it[childrenKey]"
                :key="item[valueKey]"
                class="content"
                :class="{active: item.bol}"
                @click="selectChange(item)"
              >{{item[labelKey]}}</div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="search-list" :style="{width: 110 * rowCount  + 'px'}" v-else>
          <div
            class="search-item"
            @click="searchSelect(idx)"
            v-for="(it,idx) in searchList"
            :key="idx"
          >{{it[labelKey]}}</div>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import {
    getEmptyArray,
    getEmptyObject,
    isArray
  } from "../../utils";
  export default {
    name: 'TowCascader',
    props: {
      labelKey: {
        type: String,
        default: 'label'
      },
      valueKey: {
        type: String,
        default: 'value'
      },
      childrenKey: {
        type: String,
        default: 'children'
      },
      data: {
        type: Array,
        default: getEmptyArray
      },
      value: {
        type: Array,
        default: getEmptyArray
      },
      rowCount: {
        type: Number,
        default: 4
      },
      separator: {
        type: String,
        default: '/'
      },
      showAllLevels: {
        type: Boolean,
        default: true
      },
      clearable: {
        type: Boolean,
        default: false
      },
      filterable: {
        type: Boolean,
        default: false
      },
      isHeaderLeft: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        selectValue: '',
        activeName: '',
        options: JSON.parse(JSON.stringify(this.data)),
        obj: JSON.parse(JSON.stringify(this.data)),
        searchCenter: '',
        searchArray: [],
        searchList: [],
        isValue: false
      }
    },
    created () {
      // 回显定位
      if (this.value && this.value.length) {
        this.location(this.options, this.value)
      }
      this.activeName = ''
      this.setSearchList()
    },
    methods: {
      setSearchList () {
        if (this.options.length) {
          let obj = {}
          // 树形结构转化为搜索数组
          for (let i of this.options) {
            if (i[this.childrenKey]) {
              for (let j of i[this.childrenKey]) {
                obj = {
                  [this.labelKey]: `${i[this.labelKey]}${this.separator}${j[this.labelKey]}`,
                  [this.valueKey]: [i[this.valueKey], j[this.valueKey]]
                }
                this.searchArray.push(obj)
              }
            }
          }
        }
        
      },
      // 二级选择
      selectChange (it) {
        // 重置树，清空bol值
        this.options = JSON.parse(JSON.stringify(this.obj))
        this.location(this.options, [this.activeName, it[this.valueKey]])
        this.$refs.select.toggleMenu()
        
      },
      // 回显位置方法
      location (data, val) {
        for (let i of data) {
          if (i[this.valueKey] === val[0]) {
            this.activeName = i[this.valueKey]
            if (i[this.childrenKey]) {
              for (let j of i[this.childrenKey]) {
                if (j[this.valueKey] === val[1]) {
                  j.bol = true
                  this.selectValue = j[this.labelKey]
                  if (this.showAllLevels) {
                    this.selectValue = `${i[this.labelKey]}${this.separator}${j[this.labelKey]}`
                  }
                  // 更新v-model的值
                  this.$emit('input', [i[this.valueKey], j[this.valueKey]])
                  break
                }
              }
            }
          }
        }
      },
      // 清空方法
      handleClear () {
        this.selectValue = ''
        this.$emit('input', [])
        this.options = JSON.parse(JSON.stringify(this.obj))
      },
      // 下拉显示调用
      visibleChange (it) {
        if (it) {
          // 重置树，清空bol值
          this.options = JSON.parse(JSON.stringify(this.obj))
          this.searchCenter = ''
          // 是否有默认值，回显位置
          if (this.value && this.value.length) {
            this.location(this.options, this.value)
          } else {
            this.activeName = this.options[0][this.valueKey]
          }
        }
      },
      // 搜索内容选择
      searchSelect (idx) {
        if (this.showAllLevels) {
          this.selectValue = this.searchList[idx][this.labelKey]
        } else {
          this.selectValue = this.searchList[idx][this.labelKey].split(this.separator)[1]
        }
        this.$emit('input', this.searchList[idx][this.valueKey])
      }
    },
    watch: {
      // 搜索框内容改变
      searchCenter (val) {
        this.searchList = this.searchArray.filter(item => {
          let re = new RegExp(this.searchCenter)
          if (item[this.labelKey].match(re)) {
            return true
          }
        })
      },
      data: {
        handler (val) {
          this.options = JSON.parse(JSON.stringify(val))
          this.obj = JSON.parse(JSON.stringify(val))
          this.setSearchList()
          this.location(this.options, this.value)
        },
        deep:true
      },
      value: {
        handler (val) {
          if (!this.isValue) {
            this.isValue = true
            this.location(this.options, val)
            this.activeName = ''
          }
        },
        deep:true
      }
    }
  }
</script>
<style scoped>
  .el-select-dropdown__item {
    height: auto;
    background: #fff;
  }
  .el-select-dropdown__item.hover {
    background: #fff;
  }
</style>


